export enum PlanType {
  PAY_AS_U_GO = 'PAY_AS_U_GO',
  SUBSCRIPTION_BASIC = 'SUBSCRIPTION_BASIC',
  SUBSCRIPTION_PREMIUM = 'SUBSCRIPTION_PREMIUM',
  SUBSCRIPTION_STANDARD = 'SUBSCRIPTION_STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION',
  ADD_ON = 'ADD_ON',
  BUNDLE = 'BUNDLE',
}
export enum PriceType {
  ONE_TIME = 'ONE_TIME',
  SUBSCRIPTION = 'SUBSCRIPTION',
}
export enum CurrencyCode {
  JPY = 'JPY',
  USD = 'USD',
}
export enum CurrencySymbol {
  JPY = '¥',
  USD = '$',
}
export const PAY_AS_U_GO_PLAN = 1
export const PAY_AS_U_GO_CREDIT = 1
export const CUSTOM_PLAN = 17
export const NONE_CHECKOUT_PLAN = [CUSTOM_PLAN, PAY_AS_U_GO_PLAN] //free, custom

// Storage Add-on constants
export const STORAGE_ADDON = 'storage_addon'
export const STORAGE_ADDON_PREMIUM = 'storage_addon_premium'
export const STORAGE_ADDONS = [STORAGE_ADDON, STORAGE_ADDON_PREMIUM] as const
export type StorageAddonType = typeof STORAGE_ADDONS[number]
